import { render } from "./form-event.vue?vue&type=template&id=59856593&ts=true"
import script from "./form-event.vue?vue&type=script&lang=ts"
export * from "./form-event.vue?vue&type=script&lang=ts"

import "./form-event.vue?vue&type=style&index=0&id=59856593&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__